import React from "react";
import { Link } from "react-router-dom";

export const Footer: React.FC = () => {
  return (
    <footer className="glass-card border-t border-white/10 relative z-10">
      <div className="container mx-auto px-4 py-4">
        <div className="text-center gap-2">
          <span className="text-gold-300/80 mt-2 block">
            בעזרת השם נעשה ונצליח
          </span>

          <p className="text-sm text-mystic-400 flex flex-col items-center gap-2">
            <span>© 2026 Spirit Research Lab. כל הזכויות שמורות.</span>
            <span className="flex items-center gap-4 text-xs opacity-70">
              <Link
                to="/privacy-policy"
                className="hover:text-gold-400 transition-colors"
              >
                מדיניות פרטיות
              </Link>
              <span className="text-mystic-700">|</span>
              <Link
                to="/terms-of-use"
                className="hover:text-gold-400 transition-colors"
              >
                תנאי שימוש
              </Link>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};
